<template>
  <b-form-radio-group
    v-model="internalValue"
    class="d-flex align-items-center w-100 mt-2"
    :options="options"
    :state="state"
    :placeholder="placeholder"
    :autocomplete="autocomplete"
    :disabled="disabled"
    :size="size"
    @input="handleInput"
  />
</template>

<script>
export default {
  name: 'RadioField',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Boolean, String],
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    preselected: {
      type: [Boolean, String],
      default: ''
    },
    state: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    size: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      internalValue: this.value || this.preselected
    }
  },
  methods: {
    handleInput(value) {
      !this.disabled && this.$emit('input', value)
    }
  }
}
</script>

<style scoped lang="scss">
  :deep(.custom-control-input){
    &:checked~.custom-control-label::before {
      border-color: transparent;
      background-color: transparent;
    }
  }

  :deep(.custom-radio){
    .custom-control-input:checked~.custom-control-label::after {
      background-color: white;
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.1 (78136) - https://sketchapp.com --%3E%3Ctitle%3ECheck Icon%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='FunderMaps' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Upload-D' transform='translate(-560.000000, -645.000000)' fill='%2328CC8B'%3E%3Cg id='Document-info' transform='translate(518.000000, 410.000000)'%3E%3Cg id='Selected' transform='translate(42.000000, 230.000000)'%3E%3Cpath d='M11.802,11.618 L7.693,15.798 C7.557,15.936 7.372,15.991 7.178,15.995 C7.16,15.998 7.142,16 7.124,16.001 C7.091,16 7.06,15.996 7.026,15.991 C6.841,15.981 6.664,15.927 6.533,15.794 L6.424,15.684 C6.422,15.681 6.419,15.68 6.416,15.678 C6.414,15.675 6.413,15.672 6.411,15.67 L4.208,13.437 C3.888,13.112 3.94,12.531 4.325,12.141 C4.71,11.75 5.282,11.697 5.603,12.023 L7.114,13.554 L10.407,10.204 C10.727,9.879 11.299,9.933 11.684,10.323 C12.069,10.714 12.122,11.293 11.802,11.618 M8,5 C3.582,5 0,8.582 0,13 C0,17.419 3.582,21 8,21 C12.418,21 16,17.419 16,13 C16,8.582 12.418,5 8,5' id='Check-Icon'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      background-size: cover;
    }
  }

  :deep(.custom-radio){
    &.none .custom-control-input:checked~.custom-control-label::after {
      background-color: white;
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.1 (78136) - https://sketchapp.com --%3E%3Ctitle%3ENone Icon%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='FunderMaps' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Upload-D' transform='translate(-940.000000, -673.000000)' fill='%23354052'%3E%3Cg id='Document-info' transform='translate(518.000000, 410.000000)'%3E%3Cg id='Selected' transform='translate(42.000000, 230.000000)'%3E%3Cpath d='M384,40.0393066 L392,40.0393066 C392.552285,40.0393066 393,40.4870219 393,41.0393066 C393,41.5915914 392.552285,42.0393066 392,42.0393066 L384,42.0393066 C383.447715,42.0393066 383,41.5915914 383,41.0393066 C383,40.4870219 383.447715,40.0393066 384,40.0393066 Z M388,33 C383.582,33 380,36.582 380,41 C380,45.419 383.582,49 388,49 C392.418,49 396,45.419 396,41 C396,36.582 392.418,33 388,33' id='None-Icon'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      background-size: cover;
    }
  }
</style>
